import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { UsersListState, USERS_LIST_SLICE_NAME } from './models';

export const usersListSelector = (state: RootState): UsersListState => state[USERS_LIST_SLICE_NAME];

export const selectUsersIsLoading = createSelector(usersListSelector, (state: UsersListState) => state.isLoading);

export const selectAdminsList = createSelector(usersListSelector, (state: UsersListState) => state.admins);

export const selectPartnersList = createSelector(usersListSelector, (state: UsersListState) => state.admins);

export const selectQuery = createSelector(usersListSelector, (state: UsersListState) => state.query);
export const selectUserQuery = createSelector(usersListSelector, (state: UsersListState) => state.userQuery);
